import React, { Fragment } from 'react'
import { Waypoint } from 'react-waypoint'
import classnames from 'classnames'
import Configurator from '../../configurator'
import {
    i18nWrapper,
    withRouterConnectWrapper,
} from '../../validator'
import { getBrowserHistoryFilters } from '../../front/components/filters/search-params'
import Link from '../../front/components/shared/sn-link'
import { languagePath } from '../../locales/helpers'

const grantProgramsLink = 'https://www.ostrava.cz/cs/urad/magistrat/odbory-magistratu/skolstvi-a-sportu/informace-o-poskytovani-peneznich-prostredku-z-rozpoctu-smo/telovychova-a-sport-2'

class EntitiesStripe extends Configurator {

    state = {
        isTopFixed: false,
    }

    /**
     * Set state, if stripe should be fixed to top edge
     * @param {boolean} stick
     */
    fixedToTopEdge = stick => {
        this.setState({
            isTopFixed: stick,
        })
    }

    /**
     * Render social buttons in the menu
     *
     * @returns {*}
     */
    renderSocial = () => (
        <div className="ml-4 d-inline-block">
            <a
                href={this.config.REACT_APP_FOOTER_FACEBOOK_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="text-color-gray-dark-1 social-link"
            >
                <i className="fab fa-facebook-square" />
            </a>
            <a
                href={this.config.REACT_APP_FOOTER_INSTAGRAM_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="text-color-gray-dark-1 social-link"
            >
                <i className="fab fa-instagram" />
            </a>
        </div>
    )


    /**
     * Render NavLink for sub-page
     * @param {string} link
     * @param {string} label
     * @return {*}
     */
    renderLink = (link, label) => {
        const {
            filtersName,
            location,
        } = this.props

        if (link) {
            const searchParams = '?' + getBrowserHistoryFilters([{ name: filtersName }])

            return (
                <Link
                    to={`/${link}${searchParams}`}
                    className={classnames({
                        'entities-stripe__link': true,
                        'entities-stripe__link--active': `${languagePath(false, true)}${link}` === location?.pathname?.replace?.('/', ''),
                    })}
                >
                    {label}
                </Link>
            )
        }

        return null
    }

    render() {
        const { isTopFixed } = this.state
        const { t } = this.props

        const {
            REACT_APP_TRANSLATION_ROUTES: routes,
        } = this.config

        return (
            <Fragment>
                <Waypoint
                    onEnter={() => this.fixedToTopEdge(false)}
                    onLeave={() => this.fixedToTopEdge(true)}
                    onPositionChange={e => this.fixedToTopEdge(e.currentPosition === 'above')}
                />
                <div className={classnames({
                    'entities-stripe': true,
                    'container-fluid': this.isSportnectSystem(),
                    'container': !this.isSportnectSystem(),
                    'entities-stripe--top-fixed': isTopFixed,
                })}>
                    {!this.isSportnectSystem() &&
                        <span className="entities-stripe__system">System by Sportnect</span>
                    }
                    <div className="entities-stripe__entities">
                        {this.renderLink(routes.entities, t('all'))}
                        {this.renderLink(routes.events, t('events'))}
                        {this.renderLink(routes.clubs, t('clubsAndGroups'))}
                        {this.renderLink(routes.sportVenues, t('sportVenues'))}
                        {this.renderLink(routes.community, t('community.title'))}
                        {/* {this.renderLink(routes.sportnections, t('sportnections'))} */}
                        {this.renderLink(routes.news, this.isSportnectSystem() ? t('blog') : t('articles'))}
                        {/*{this.renderLink(routes.contact, t('contacts'))}*/}
                        {this.renderSocial()}
                    </div>
                </div>
                {isTopFixed && <div className="entities-stripe--offset-fixed-height" />}
            </Fragment>
        )
    }
}

export default withRouterConnectWrapper(({ filters }) => ({
    filtersName: filters.name,
}))(i18nWrapper(EntitiesStripe))
